import { render, staticRenderFns } from "./CustomerPoolsStandard.vue?vue&type=template&id=9fb80df4"
import script from "./CustomerPoolsStandard.vue?vue&type=script&lang=ts"
export * from "./CustomerPoolsStandard.vue?vue&type=script&lang=ts"
import style0 from "./CustomerPoolsStandard.vue?vue&type=style&index=0&id=9fb80df4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports